import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getTicketDateTimeTextStyles } from 'common/entities/form/styleConfiguration/selectors';
import {
    setTicketDateTimeTextFont,
    setTicketDateTimeTextFontsize,
    setTicketDateTimeTextColor,
} from 'common/entities/form/styleConfiguration/actions';
import { getDefaultStyle, styleShapePropTypes } from 'common/entities/form/styleConfiguration/utils';
import {
    DEFAULT_FONT,
    DEFAULT_SMALL_TICKET_FONT_SIZE,
    DEFAULT_TICKET_DATE_TIME_COLOR,
} from 'common/entities/form/styleConfiguration/defaultValues';
import DefaultFontTicketStylePanel from './DefaultFontTicketStylePanel';
import { getFormId, getOpenTicketStylingType } from '../../../../selectors';
import { DATE_TIME_QA } from '../../../../constants/ticketDataQa';
import { DATE_TIME_LABEL } from '../../../../constants/formStyleLabels';

const FormStyleTicketEditorDateTimePanel = (props) => (
    <DefaultFontTicketStylePanel
        ticketPanelQaId={DATE_TIME_QA}
        setTicketPanelFontFamily={props.setTicketDateTimeTextFont}
        setTicketPanelFontSize={props.setTicketDateTimeTextFontsize}
        setTicketPanelTextColor={props.setTicketDateTimeTextColor}
        {...props}
        componentLabel={DATE_TIME_LABEL}
    />
);

FormStyleTicketEditorDateTimePanel.propTypes = {
    formId: PropTypes.string.isRequired,
    color: styleShapePropTypes,
    font: styleShapePropTypes,
    fontSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    setTicketDateTimeTextFont: PropTypes.func.isRequired,
    setTicketDateTimeTextFontsize: PropTypes.func.isRequired,
    setTicketDateTimeTextColor: PropTypes.func.isRequired,
};

FormStyleTicketEditorDateTimePanel.defaultProps = {
    color: getDefaultStyle(DEFAULT_TICKET_DATE_TIME_COLOR),
    font: getDefaultStyle(DEFAULT_FONT),
    fontSize: DEFAULT_SMALL_TICKET_FONT_SIZE,
};

const mapStateToProps = (state) => {
    const formId = getFormId(state);
    const openTicketType = getOpenTicketStylingType(state);

    const { color, font, fontSize } = getTicketDateTimeTextStyles(state, formId, openTicketType);

    return {
        formId,
        color,
        font,
        fontSize,
    };
};

const mapDispatchToProps = {
    setTicketDateTimeTextFont,
    setTicketDateTimeTextFontsize,
    setTicketDateTimeTextColor,
};

export default connect(mapStateToProps, mapDispatchToProps)(FormStyleTicketEditorDateTimePanel);
